<script lang="ts" setup>
  import { computed } from 'vue';
  import { CriticalErrorLayout } from '@storefront/components';
  import { useTranslator } from '@othercommerce/foundation';

  defineOptions({
    layout: CriticalErrorLayout,
  });

  interface Props {
    title?: string | null;
    description?: string | null;
  }

  const props = defineProps<Props>();
  const translator = useTranslator();

  const title = computed(() => {
    return props.title || translator.trans('SHOP.ERROR.HEADER.500');
  });

  const description = computed(() => {
    return props.description || translator.trans('SHOP.ERROR.MESSAGE.500');
  });
</script>
<template>
  <div class="generic-error">
    <h1>{{ title }}</h1>
    <div class="generic-error__description" v-html="description" />
    <SfButton :href="$route('web.homepage.index')" primary>
      {{ $t('SHOP.ACTION.HOMEPAGE') }}
    </SfButton>
  </div>

  <RouterView />
</template>
<style lang="scss" scoped>
  .generic-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;

    h1 {
      text-align: center;
    }

    &__description {
      max-width: 600px;
      text-align: center;
    }
  }
</style>
